import type { Enums } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getUnitIcon(unit: Enums<"unit"> | "days"): IconName {
	switch (unit) {
		case "business-days":
		case "work-days":
		case "calendar-days":
			return "Calendar";
		case "cubic-meters":
			return "Box";
		case "meters":
		case "meters-week":
			return "Ruler";
		case "number":
		case "piece":
		case "piece-week":
			return "Tally5";
		case "percent":
			return "Percent";
		case "square-meters":
		case "square-meters-week":
			return "Square";
		case "currency":
			return "Euro";
		case "days":
			return "Calendar1";
		case "flat-rate":
			return "BadgeCheck";
		default:
			return "BadgeInfo";
	}
}
